import { createSlice } from '@reduxjs/toolkit';

let initialState = {
    loading: false,
    getPatientsRes: null,
    resetPasswordRes: null,
    sendResetEmailRes: null,
    toggleImageAccessRes: null,
};

const slice = createSlice({
    name: 'patients',
    initialState,
    reducers: {
        // Get patients list
        getPatientsRequest: (state) => {
            state.loading = true;
        },
        getPatientsSuccess: (state, action) => {
            state.loading = false;
            state.getPatientsRes = action.payload;
        },
        getPatientsFailure: (state, action) => {
            state.loading = false;
            state.getPatientsRes = action.payload;
        },
        resetGetPatients: (state) => {
            state.getPatientsRes = null;
        },

        // Reset password manually
        resetPasswordRequest: (state) => {
            state.loading = true;
        },
        resetPasswordSuccess: (state, action) => {
            state.loading = false;
            state.resetPasswordRes = action.payload;
        },
        resetPasswordFailure: (state, action) => {
            state.loading = false;
            state.resetPasswordRes = action.payload;
        },
        clearResetPassword: (state) => {
            state.resetPasswordRes = null;
        },

        // Send reset email
        sendResetEmailRequest: (state) => {
            state.loading = true;
        },
        sendResetEmailSuccess: (state, action) => {
            state.loading = false;
            state.sendResetEmailRes = action.payload;
            // Update the patient in the list to show email was sent
            if (state.getPatientsRes?.data && action.payload?.patientId) {
                state.getPatientsRes.data = state.getPatientsRes.data.map(patient =>
                    patient._id === action.payload.patientId
                        ? { ...patient, welcomeEmailSent: true }
                        : patient
                );
            }
        },
        sendResetEmailFailure: (state, action) => {
            state.loading = false;
            state.sendResetEmailRes = action.payload;
        },
        clearSendResetEmail: (state) => {
            state.sendResetEmailRes = null;
        },

        // Toggle image access
        toggleImageAccessRequest: (state) => {
            state.loading = true;
        },
        toggleImageAccessSuccess: (state, action) => {
            state.loading = false;
            state.toggleImageAccessRes = action.payload;
            // Update the patient in the list
            if (state.getPatientsRes?.data && action.payload?.patientId) {
                state.getPatientsRes.data = state.getPatientsRes.data.map(patient =>
                    patient._id === action.payload.patientId
                        ? { ...patient, canViewImages: action.payload.canViewImages }
                        : patient
                );
            }
        },
        toggleImageAccessFailure: (state, action) => {
            state.loading = false;
            state.toggleImageAccessRes = action.payload;
        },
        clearToggleImageAccess: (state) => {
            state.toggleImageAccessRes = null;
        },
    }
});

export const {
    getPatientsRequest,
    getPatientsSuccess,
    getPatientsFailure,
    resetGetPatients,
    resetPasswordRequest,
    resetPasswordSuccess,
    resetPasswordFailure,
    clearResetPassword,
    sendResetEmailRequest,
    sendResetEmailSuccess,
    sendResetEmailFailure,
    clearSendResetEmail,
    toggleImageAccessRequest,
    toggleImageAccessSuccess,
    toggleImageAccessFailure,
    clearToggleImageAccess,
} = slice.actions;

export default slice.reducer;
